import FormTextInput from "./FormTextInput";

const FormEmailInput = ({ ...rest }) => {
    const emailMatch = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    return (<FormTextInput {...rest} rules={{ ...rest.rules, pattern: { value: emailMatch, message: "invalid email" } }} />)
}

export default FormEmailInput